import React from 'react';
import RetailerTypeHeaderDropdown from './ui/RetailerTypeHeaderDropdown';
import RegionHeaderDropdown from './ui/RegionHeaderDropdown';
import { ChannelPicker } from './types/ChannelPicker';
import { RetailerItemsPicker } from './types/RetailerItemsPicker';

const HeaderSelectors = ({
  channelPicker,
  retailSelectionPicker,
}: {
  channelPicker: ChannelPicker;
  retailSelectionPicker: RetailerItemsPicker;
}) => {
  return (
    <div className="flex gap-4">
      <RetailerTypeHeaderDropdown
        currentRegionUrl={retailSelectionPicker.currentRegionUrl}
        options={retailSelectionPicker.retailerSelectionItems}
        selectedOption={retailSelectionPicker.currentRetailerSelection}
      />
      <RegionHeaderDropdown
        options={channelPicker.channelPickerItems}
        selectedOption={channelPicker.currentChannel}
      />
    </div>
  );
};

export default HeaderSelectors;
